"use strict";

exports.__esModule = true;
exports.getRandomUser = getRandomUser;
exports.default = void 0;

var _user = _interopRequireDefault(require("../data/user"));

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const men = ["Random Ronald", "Random Rex", "Random Ronny", "Random Rolf"];
const portraitsOfMen = ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAGJ3K2RXdlwLoumBPOFD2yKbAuByhl_T5_uf6VI92MaHupq_4", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZANu2fqqgBtSNpeypVB5NaK2ruhRaQeySJE-309AKguQb9tK3tA", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXt1_6g63bTxOElh_a9Uz8gW9HfOB6XCQlStHCE7IJz9tzKV-b", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOJIyovNACmvWdah0q19bfziU9C6I3VffgIHPU6QdWzDEQOmoT4w", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRenr0iBRHcVSxfHmgTbF_bH_3cQa3SfQCwLDRbZiIlH1BkRdZI"];
const women = ["Random Ronja", "Random Rakel", "Random Rene", "Random Rio"];
const portraitsOfWomen = ["https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNVRX-3i4PrEztK93_oFJRMKcB82Hben3hMCfEzMNjuhNjDTf6sg", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcy0OavN0OWW45xqfK6qKCCNKstVb7BX-YzBHL71JPw-Tbzmmv", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDXZIqbMKAe1G0LmmGdqpXQIogIFmaRDLXsD2YmGMktJMto5g3", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSR_gJRvMo_kJ9H3S9sDTQYY4xPaA2I21Xo-I_rYXZ6XYLrR6GkgA", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi2KrrADwKy9Ap8nv9uVQ4g7aKUeIuSwVuAQuF0klfHKho9QWm1g"];
const genders = ["male", "female"];
const names = {
  "male": men,
  "female": women
};
const portraits = {
  "male": portraitsOfMen,
  "female": portraitsOfWomen
};

function getRandomUser() {
  const gender = (0, _.getRandomArrayItem)(genders);
  const name = (0, _.getRandomArrayItem)(names[gender]);
  const imageUrl = (0, _.getRandomArrayItem)(portraits[gender]);
  const email = name.split(' ').join('.').toLowerCase() + "@kulturit.no";
  return _extends({}, _user.default, {
    uniqueId: "user-x",
    gender: gender,
    name: name,
    email: email,
    imageUrl: imageUrl,
    theme: (0, _.getRandomTheme)()
  });
}

var _default = getRandomUser;
exports.default = _default;